import OnboardingLayout from "@/components/layout/OnboardingLayout";
import { Outlet } from "react-router-dom";
import { useUIv2 } from '@/hooks/useUIv2'
import OnboardingV2 from './OnboardingV2'

const Onboarding = () => {
  const isV2 = useUIv2()

  if (isV2) {
    return <OnboardingV2 />
  }

  return (
    <OnboardingLayout>
      <Outlet />
    </OnboardingLayout>
  )
}

export default Onboarding;